import { makeStyles, mergeClasses, useTabListStyles_unstable } from '@fluentui/react-components';
import type {
  GroundingCommandBarTabListSlots,
  GroundingCommandBarTabListState,
} from './GroundingCommandBarTabList.types';
import type { SlotClassNames } from '@fluentui/react-components';

export const groundingCommandBarTabListClassNames: SlotClassNames<GroundingCommandBarTabListSlots> = {
  root: 'fai-GroundingCommandBarTabList',
  overflowMenu: 'fai-GroundingCommandBarTabList__overflowMenu',
};

/**
 * Styles for the root slot
 */
const useStyles = makeStyles({
  root: {
    gridArea: 'tabs',
    overflow: 'hidden',
    width: '100%',
    gap: 0,
  },
});

/**
 * Apply styling to the GroundingCommandBarTabList slots based on the state
 */
export const useGroundingCommandBarTabListStyles_unstable = (
  state: GroundingCommandBarTabListState,
): GroundingCommandBarTabListState => {
  'use no memo';

  const styles = useStyles();
  state.root.className = mergeClasses(groundingCommandBarTabListClassNames.root, styles.root, state.root.className);

  if (state.overflowMenu) {
    state.overflowMenu.className = mergeClasses(
      groundingCommandBarTabListClassNames.overflowMenu,
      state.overflowMenu.className,
    );
  }

  useTabListStyles_unstable(state);

  return state;
};
